var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleEmailAndSms24X24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7317_109559)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.75,
    fill: "#907CF5",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8231 8.01156C4.082 7.81801 1.81801 10.082 2.01156 12.8231C2.17359 15.2041 4.25304 17 6.63856 17H8.29942C8.54697 17 8.74951 16.7975 8.74951 16.5499C8.74951 16.3024 8.54697 16.0998 8.29942 16.0998H6.64756C4.9687 16.0998 3.42936 15.0106 3.01077 13.3857C2.34013 10.7752 4.77065 8.34013 7.38122 9.01527C9.01057 9.42936 10.0998 10.9687 10.0998 12.6476V13.1427C10.0998 13.4982 9.78024 13.8493 9.42466 13.8493C9.06908 13.8493 8.74951 13.4982 8.74951 13.1427V12.58C8.74951 11.4503 7.94834 10.4331 6.8321 10.2755C5.30177 10.055 4.00999 11.3783 4.28455 12.9176C4.43758 13.7773 5.10823 14.4885 5.95891 14.691C6.78709 14.8845 7.57476 14.619 8.09237 14.0924C8.49296 14.6415 9.29413 14.9296 10.0278 14.637C10.6309 14.3984 11 13.7818 11 13.1337V12.6431C11 10.253 9.20411 8.17359 6.8231 8.01156ZM6.49902 13.8494C5.75186 13.8494 5.14873 13.2462 5.14873 12.4991C5.14873 11.7519 5.75186 11.1488 6.49902 11.1488C7.24618 11.1488 7.84931 11.7519 7.84931 12.4991C7.84931 13.2462 7.24618 13.8494 6.49902 13.8494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0H13V24H12.5V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7317_109559)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12,
    r: 11.75,
    fill: "#94C696",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.375 15.6875H16.625C15.5 15.6875 14.75 15.125 14.75 13.8125V11.1875C14.75 9.875 15.5 9.3125 16.625 9.3125H20.375C21.5 9.3125 22.25 9.875 22.25 11.1875V13.8125C22.25 15.125 21.5 15.6875 20.375 15.6875Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.375 11.375L19.2012 12.3125C18.815 12.62 18.1812 12.62 17.795 12.3125L16.625 11.375",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7317_109559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7317_109559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 24,
    fill: "white",
    transform: "translate(13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleEmailAndSms24X24);
export default __webpack_public_path__ + "static/media/circle-email-and-sms-24x24.4270fe0493483851e56044428d35d3a0.svg";
export { ForwardRef as ReactComponent };